import { render, staticRenderFns } from "./SupportForm.vue?vue&type=template&id=7f04302c&scoped=true"
import script from "./SupportForm.vue?vue&type=script&lang=js"
export * from "./SupportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f04302c",
  null
  
)

export default component.exports